import React, { useEffect, useState } from 'react'
import { StyleSheet, SafeAreaView } from 'react-native'
import ProductList from '../../components/ProductList'
import { useAtomValue } from 'jotai'
import { productCategoriesDictAtom, productsDictAtom, productsUpdatedAtom, userStoreIdAtom } from '../../global/AtomsProvider'
import { getIngredientsForProductByCategoryList } from '../../utils/productListHelpers'
import { newFuse } from '../../utils/fuseHelper'

export default function AddIngredientToProductScreen( { navigation, route } ) {
  const { data, setData, parentProduct } = route.params
  const productsDict = useAtomValue(productsDictAtom)
  const productCategoriesDict = useAtomValue(productCategoriesDictAtom)
  const productsUpdate = useAtomValue(productsUpdatedAtom)
  const [filteredProducts, setFilteredProducts] = useState(getIngredientsForProductByCategoryList(parentProduct, productsDict, productCategoriesDict, false, null))
  const [fuse, setFuse] = useState(newFuse(filteredProducts))

  useEffect(() => {
    let newCustomList = getIngredientsForProductByCategoryList(parentProduct, productsDict, productCategoriesDict, false, null)
    setFilteredProducts(newCustomList) 
    setFuse(newFuse(newCustomList))
  }, [productsUpdate])

  const onItemPress = (item, index, store) => {
    var newData = [...data]
    newData.push({...item, quantity: 1})
    setData(newData)
    navigation.goBack()
  }

  return (
    <SafeAreaView style={styles.container}>
      <ProductList preselectedStore='all' products={filteredProducts} customFuse={fuse} onItemPress={onItemPress} />
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'stretch',
  }, 
});
